import { useMutation } from 'react-query';

import { castPollVote } from '@utils/backend-api/forumPosts';

export default function usePollVote() {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    ({ forumPostId, pollOptionId }: { forumPostId: number | string; pollOptionId: number }) =>
      castPollVote({ forumPostId, pollOptionId })
  );
  return { mutate, mutateAsync, isLoading, isError };
}
